export default "__VITE_ASSET__BN0Nm2T$__"